import type { Entry } from 'contentful'
import ArticleBreadcrumb from '@/components/article-breadcrumb'
import PageWrapper from '@/components/page-wrapper'
import Container from '@/components/container'
import Image from '@/components/ui/image'
import Video from '@/components/ui/video'
import CtaLink, { buttonStyles } from '@/components/ui/cta-link'
import Link from '@/components/link-component'
import colors from '@/constants/colors'
// import { getLocale } from '@plugins/bw-i18next'
import { dateDiff, dateTimeFormat } from '@/utils/strings'
import type { TypeEventsSkeleton } from '@/types/ctf'

type TypeEvent = Entry<TypeEventsSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>

type EventPageProps = {
  fields: TypeEvent['fields']
}

export default function EventPage({ fields, footerNav, headerNav, headerBanners, newsletterForm }: EventPageProps) {
  const { downloadLink, eventDate, link, video, seo } = fields

  const downloadIsPDF = downloadLink?.fields?.url?.endsWith('.pdf')
  const breadcrumb = [{ name: 'Events', path: '/events/' }, { name: seo?.fields.title }]
  return (
    <PageWrapper
      seo={seo}
      breadcrumb={breadcrumb}
      headerNav={headerNav}
      footerNav={footerNav}
      newsletterForm={newsletterForm}
      headerBanners={headerBanners}
    >
      <Container>
        <ArticleBreadcrumb className="mt-10" breadcrumb={breadcrumb} />
        <section className="lg:py-12 grid gap-8 lg:grid-cols-2 min-h-[50vh]">
          {video?.fields.url ? <Video {...video} /> : <Image image={seo?.fields.ogImage} />}
          <div className="lg:row-start-1">
            <h1 className="h3">{seo?.fields?.title}</h1>
            {eventDate && (
              <div className="mt-1 font-medium text-sm text-secondary-500">
                {/* TODO: Get locale */}
                {dateTimeFormat(eventDate, 'en-US')}
                <br />({dateDiff(eventDate, 'en-US')})
              </div>
            )}
            {seo?.fields?.description && <div className="mt-4 max-w-md">{seo.fields.description}</div>}
            <div className="flex flex-col gap-1 mt-4 sm:items-center sm:flex-row">
              {link?.fields?.url && (
                <CtaLink to={link.fields.url} style={buttonStyles.btnSolid} backgroundColor={colors.white}>
                  View Event
                </CtaLink>
              )}
              {downloadLink?.fields?.url && (
                <CtaLink to={downloadLink.fields.url} style={buttonStyles.btnOutlined} backgroundColor={colors.white}>
                  {downloadIsPDF ? (
                    <>
                      Download PDF <span className="font-bwi text-base ml-1">&#xe928;</span>
                    </>
                  ) : (
                    <>
                      Open Slide Deck <span className="font-bwi text-base ml-1">&#xe91c;</span>
                    </>
                  )}
                </CtaLink>
              )}
            </div>
            <div className="text-primaryBlue mt-6 hover:text-indigoBlue pb-10">
              <span className="font-bwi text-primaryBlue dark:text-white">&#xe96b;</span>
              <Link to="/events/">Back to all Events</Link>
            </div>
          </div>
        </section>
      </Container>
    </PageWrapper>
  )
}
